import { TYPE_PDF } from '@/configuration/edition/editionConf';

export const DECLARATION = 'Declaration';
export const DECLARATION_AU_FIL_DE_LEAU = 'FilDeLeau';
export const MATERIEL_EN_PLACE = 'MaterielEnPlace';
export const MONTAGES_ANNEE_PREC = 'MontagesAnneePrec';
export const DEMONTAGES_ANNEE_PREC = 'DemontageAnneePrec';
export const MONTAGE_AU_FIL_DE_L_EAU = 'MontageFilDeLeau';
export const DEMONTAGE_AU_FIL_DE_L_EAU = 'DemontageFilDeLeau';

export const LISTE_TYPE_DECLARATION = [
  { code: DECLARATION, libelle: 'listeCommandeTlpe.typeDeclaration.declaration' },
  { code: DECLARATION_AU_FIL_DE_LEAU, libelle: 'listeCommandeTlpe.typeDeclaration.declarationFilDeLeau' },
  { code: MATERIEL_EN_PLACE, libelle: 'listeCommandeTlpe.typeDeclaration.materielEnPlace' },
  { code: MONTAGES_ANNEE_PREC, libelle: 'listeCommandeTlpe.typeDeclaration.montagesAnneePrec' },
  { code: DEMONTAGES_ANNEE_PREC, libelle: 'listeCommandeTlpe.typeDeclaration.demontageAnneePrec' },
  { code: MONTAGE_AU_FIL_DE_L_EAU, libelle: 'listeCommandeTlpe.typeDeclaration.montageFilDeLeau' },
  { code: DEMONTAGE_AU_FIL_DE_L_EAU, libelle: 'listeCommandeTlpe.typeDeclaration.demontageFilDeLeau' },
];

export const LISTE_TYPE_DECLARATION_CLASSIQUE = [
  { code: DECLARATION, libelle: 'listeCommandeTlpe.typeDeclaration.declaration' },
  { code: DECLARATION_AU_FIL_DE_LEAU, libelle: 'listeCommandeTlpe.typeDeclaration.declarationFilDeLeau' },
  { code: MATERIEL_EN_PLACE, libelle: 'listeCommandeTlpe.typeDeclaration.materielEnPlace' },
  { code: MONTAGES_ANNEE_PREC, libelle: 'listeCommandeTlpe.typeDeclaration.montagesAnneePrec' },
  { code: DEMONTAGES_ANNEE_PREC, libelle: 'listeCommandeTlpe.typeDeclaration.demontageAnneePrec' },
];

export const LISTE_TYPE_DECLARATION_AU_FIL_DE_LEAU = [
  { code: MONTAGE_AU_FIL_DE_L_EAU, libelle: 'declarationTlpe.listes.declarations.materielMontage' },
  { code: DEMONTAGE_AU_FIL_DE_L_EAU, libelle: 'declarationTlpe.listes.declarations.materielDemontage' },
];

export const TYPE_EDITION_COMMANDE_R_TLPE = 'CommandeReglementTLPE';
export const TYPE_EDITION_COURRIER = 'CourrierDaccompagnement';
export const EXPORT_EXCEL_LIGNE_COMMANDE_TLPE = 'lignecommandetlpe';
export const EXPORT_EXCEL_COMMANDE_TLPE = 'commandetlpe';

export const ACTION_EDIT_MATERIEL_TLPE = 'editMaterielTlpe';
export const ACTION_GENERATION_COMMANDES_TLPE = 'generationCommandesTlpe';
export const ACTION_IMPRESSION_COMMANDES_TLPE = 'impressionCommandesTlpe';

export const DISPOSITIF_PUBLICITAIRE = 'DispositifPublicitaire';
export const ENSEIGNE_SCELLEE = 'EnseigneScellee';
export const ENSEIGNE_NON_SCELLEE = 'EnseigneNonScellee';
export const PREENSEIGNE = 'Preenseigne';
export const DISPOSITIF_PUBLICITAIRE_DCM = 'DispositionPublicitaireDCM';
export const DISPOSITIF_PUBLICITAIRE_DMU = 'DispositifPublicitaireDMU';

export const LISTE_DESCRIPTION_TLPE = [
  { code: DISPOSITIF_PUBLICITAIRE, libelle: 'materiel.descriptionTlpe.dispositifPublicitaire.libelle', libelleCourt: 'materiel.descriptionTlpe.dispositifPublicitaire.libelleCourt' },
  { code: ENSEIGNE_SCELLEE, libelle: 'materiel.descriptionTlpe.enseigneScellee.libelle', libelleCourt: 'materiel.descriptionTlpe.enseigneScellee.libelleCourt' },
  { code: ENSEIGNE_NON_SCELLEE, libelle: 'materiel.descriptionTlpe.enseigneNonScellee.libelle', libelleCourt: 'materiel.descriptionTlpe.enseigneNonScellee.libelleCourt' },
  { code: PREENSEIGNE, libelle: 'materiel.descriptionTlpe.preenseigne.libelle', libelleCourt: 'materiel.descriptionTlpe.preenseigne.libelleCourt' },
  { code: DISPOSITIF_PUBLICITAIRE_DCM, libelle: 'materiel.descriptionTlpe.dispositionPublicitaireDCM.libelle', libelleCourt: 'materiel.descriptionTlpe.dispositionPublicitaireDCM.libelleCourt' },
  { code: DISPOSITIF_PUBLICITAIRE_DMU, libelle: 'materiel.descriptionTlpe.dispositifPublicitaireDMU.libelle', libelleCourt: 'materiel.descriptionTlpe.dispositifPublicitaireDMU.libelleCourt' },
];

export const LISTE_CHOIX_EDITION_DECLARATIONS_TLPE = [
  {
    typeEdition: TYPE_EDITION_COMMANDE_R_TLPE,
    libelle: 'declarationTlpe.edition.declarationsTlpe',
    typeDonnee: TYPE_EDITION_COMMANDE_R_TLPE,
    extentions: [TYPE_PDF],
  },
  { typeEdition: TYPE_EDITION_COURRIER, libelle: 'declarationTlpe.edition.courrierAccompagnement', typeDonnee: TYPE_EDITION_COURRIER },
];

export const TITRE_RECETTE_STORE = 'titreRecette';
export const TITRE_RECETTE_COLLECTIVITE_STORE = 'titreRecetteCollectivite';
export const PAIEMENT_RECETTE_STORE = 'paiementRecette';
export const LOT_PAIEMENT_RECETTE_STORE = 'lotPaiementRecette';
export const JOURNAL_PAIEMENT_RECETTE_STORE = 'journalPaiementRecette';
